module.exports = __webpack_public_path__ + "img/youngcare.1169b26.png";